import { handleFirstTab } from "../../core/js/utilities";
import * as Broker from "../../core/js/icc/broker";
import Accordion from "./accordion/accordion";
import ActionMenu from "./action-menu/action-menu";
import Breadcrumb from "./breadcrumb/breadcrumb";
import Calendar from "./date-picker/calendar";
import DatePicker from "./date-picker/date-picker";
import Drawer from "./drawer/drawer";
import Dropdown from "./dropdown/dropdown";
import FileInput from "./file-input/file-input";
import Form from "./form/form";
import InputPassword from "./input-password/input-password";
import InputMask from "./input-mask/input-mask";
import LoadingIndicator from "./loading-indicator/loading-indicator";
import MessageBar from "./message-bar/message-bar";
import Modal from "./modal/modal";
import MoreLess from "../../core/components/view-more-less/view-more-less";
import Notification from "./notification/notification";
import Pagination from "./pagination/pagination";
import Popover from "./popover/popover";
import Select from "./select/select";
import SideNav from "./side-nav/side-nav";
import Tabs from "../../core/components/tabs/tabs";
import Table from "./table/table";
import Tag from "./tag/tag";
import TextArea from "./text-area/text-area";
import Tooltip from "./tooltip/tooltip";

window.addEventListener("keydown", handleFirstTab);

export {
    handleFirstTab,
    Broker,
    Accordion,
    ActionMenu,
    Breadcrumb,
    Calendar,
    DatePicker,
    Drawer,
    Dropdown,
    FileInput,
    Form,
    InputPassword,
    LoadingIndicator,
    MessageBar,
    Modal,
    MoreLess,
    Notification,
    Pagination,
    Popover,
    InputMask,
    Select,
    SideNav,
    Tabs,
    Tag,
    Table,
    TextArea,
    Tooltip,
};
